import React, {Component} from 'react'
import {Card} from 'antd'

const withLoadingSection = WrappedComponent => {
  return class extends Component {
    render() {
      const {loading} = this.props
      if (loading === true) return <Card loading={true} style={{margin: 10}} />
      else return <WrappedComponent {...this.props} />
    }
  }
}
withLoadingSection.defaultProps = {loading: true}

export default withLoadingSection
